/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/kid_number'
export default icon
